/**
 * Błąd z API sprowadzony do jednego kształtu.
 *
 * Backend NIE zwraca gotowych zdań — oddaje `code` będący **kluczem i18n**
 * plus `args` do podstawienia (spec 4C, `Dydation.Api/ResultActions.cs`).
 * Dzięki temu backend nigdy nie staje się po cichu źródłem polskich tekstów.
 * Tłumaczenie jest wyłącznie po tej stronie.
 */
export class ApiError extends Error {
  readonly status: number;
  /** Klucz i18n, np. `graph.relation.second_parent`. */
  readonly code: string;
  /** Argumenty do podstawienia w tłumaczeniu, np. `{ parentTitle: 'Płatności' }`. */
  readonly args: Readonly<Record<string, unknown>>;

  constructor(
    status: number,
    code: string,
    args: Record<string, unknown> = {},
  ) {
    // `message` jest dla dziennika i narzędzi deweloperskich, NIE dla użytkownika.
    super(`${status} ${code}`);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.args = args;
  }

  /** Sesja wygasła albo jej nie było — wymaga przelogowania, nie komunikatu o błędzie. */
  get isUnauthorized(): boolean {
    return this.status === 401;
  }

  /** Zalogowany, ale bez uprawnień — komunikat ma sens, przelogowanie nie. */
  get isForbidden(): boolean {
    return this.status === 403;
  }

  /**
   * Kolizja stanu: ktoś nas uprzedził. Dla optimistic UI to sygnał
   * „wycofaj i pokaż aktualny stan", a nie „awaria".
   */
  get isConflict(): boolean {
    return this.status === 409;
  }
}

/** Błąd sieci albo odpowiedź, której nie da się odczytać jako `ProblemDetails`. */
export const NETWORK_ERROR_CODE = 'common.error.network';
export const UNEXPECTED_ERROR_CODE = 'common.error.unexpected';
